import React, { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
// import Notification from "rc-notification";
import axios from "axios";
import { ModalUsePortal } from "../../components/ModalUsePortal";
import { Button } from "../../components/Button";
import { Input } from "../../components/Input";
import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";
import "./styles.less";
import { tryAgl, tryAglAPI } from "../../utils/tryAgl";
import { tryNow, tryNowRegister } from "../../utils";

export const ConsultFormModal = (props) => {
  const { visible, setVisible } = props;
  const { handleSubmit, register, errors, reset, getValues } = useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [showNotice, setShowNotice] = useState(false);
  const [userPhone, setUserPhone] = useState(null);

  const onSubmit = async (values) => {
    setLoading(true);
    setUserPhone(values.phone);
    const clue = {
      utm_source: sessionStorage?.getItem("utm_source") || "",
      utm_medium: sessionStorage?.getItem("utm_medium") || "",
      utm_campaign: sessionStorage?.getItem("utm_campaign") || "",
      utm_term: sessionStorage?.getItem("utm_term") || "",
    };
    const clueValues = Object.assign({}, values, clue);
    try {
      const { data: res } = await axios.post("/api/contact-us", clueValues);
      if (res.code === 200) {
        // setVisible(false);
        setShowNotice(true);

        setLoading(false);
        // tryAgl();
        // tryAglAPI();

        reset();
      }
    } finally {
      // setVisible(false);
      setLoading(false);
      setShowNotice(true);
    }
  };

  const onError = (errors, e) => {
    console.log(errors);
  };

  const notice = () => {
    return (
      <div className="notice-block">
        <div className="notice-title">{t("common.form.success-tip")}</div>
        <div
          className="notice-close"
          onClick={() => {
            setVisible(false);
            setLoading(false);
            setShowNotice(false);
          }}
        >
          <i className="icon authing-icon authing-guanbi"></i>
        </div>
        <div className="notice-img">
          <img
            src="//files.authing.co/authing-website/consult-form-img.png"
            alt="authing"
          />
        </div>
        <div className="notice-img-tip">
          {t("common.form.success-wait-tip")}
        </div>
        <div className="notice-try-tip">{t("common.form.success-try-tip")}</div>
        <div className="notice-button-warp">
          <div
            className="button-wait"
            onClick={() => {
              setVisible(false);
              setLoading(false);
              setShowNotice(false);
            }}
          >
            {t("common.button.wait-consult")}
          </div>
          <div
            className="button-try"
            onClick={() => {
              tryNowRegister(userPhone);
            }}
          >
            {t("common.button.try-now")}
          </div>
        </div>
      </div>
    );
  };
  const form = () => {
    return (
      <div className="consult-form">
        <div className="form-top">
          <div className="form-title">
            {t("common.form.contact-form-title")}
          </div>
          <div className="form-subtitle">
            {t("common.form.contact-subtitle")}
          </div>
          <div
            className="form-close"
            onClick={() => {
              setVisible(false);
              setLoading(false);
              setShowNotice(false);
            }}
          >
            <i className="icon authing-icon authing-guanbi"></i>
          </div>
        </div>

        <form onSubmit={handleSubmit(onSubmit, onError)}>
          <div className="form-item">
            <div className="input">
              <Input
                error={errors.name}
                placeholder={t("common.form.name")}
                name="name"
                inputRef={register({
                  required: true,
                  pattern: {
                    value: /^[^\s]*$/,
                    message: "error message",
                  },
                })}
              />
            </div>
          </div>
          <div className="form-item">
            <div className="input">
              <Input
                name="phone"
                error={errors.phone}
                placeholder={t("common.form.phone")}
                inputRef={register({
                  required: true,
                  pattern: {
                    value: /^1[3-9]\d{9}$/,
                    message: "error message",
                  },
                })}
              />
            </div>
          </div>
          <div className="form-item">
            <div className="input">
              <Input
                name="company"
                placeholder={t("common.form.company")}
                inputRef={register()}
              />
            </div>
          </div>

          <div className="form-item">
            <div className="input">
              <Input
                name="other"
                placeholder={t("common.form.other")}
                error={errors.other}
                inputRef={register()}
              />
            </div>
          </div>
          <div className="form-item">
            <Button type="submit" className="consult-submit" disabled={loading}>
              {loading ? (
                <ReactLoading
                  type={"spin"}
                  height={20}
                  width={20}
                  delay={0}
                  className={"spin-loading"}
                />
              ) : (
                ""
              )}

              {t("common.form.submit")}
            </Button>
          </div>
        </form>
        <div className="form-bottom">
          <div>{t("common.form.otherTip")}</div>
          <div>
            {t("common.form.otherTip1")}
            <span className="count">400-6197-031</span>
            {t("common.form.otherTip2")}
          </div>
        </div>
      </div>
    );
  };
  return (
    <ModalUsePortal show={visible}>
      <div className="consult-form-modal">{showNotice ? notice() : form()}</div>
    </ModalUsePortal>
  );
};
